import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { authService } from '../firebase'
import { sendSignInLinkToEmail } from "firebase/auth"
import { emailCheck } from "../functions/auth"

const useStyles = makeStyles((theme) => ({

    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "680px",

    },
    wrapper: {
        width: "600px",
        "@media(max-width:770px)": {
            width: "90%",
            // overflow: "hidden"
        }

    },
    write: {
        marginTop: "25px",
        color: "#666",
        fontSize: "16px",
        fontWeight: "400",
        //fontFamily: ""
    },
    email: {
        width: "100%",
        height: "59px",

        border: "0",

        backgorundColor: "#fff",
        borderRadius: "3px",
        // color: theme.palette.primary.main,
        fontSize: "23px",
        fontWeight: "400",
        //boxShadow: "0 10px 10px rbg(225 225 225)",
        //  outlineBorder: "0",
        "&:focus": {
            outline: "2px solid",
        }




    },

    button: {

        width: "100%",
        border: "0",
        borderRadius: "6px",
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        fontSize: "30px",
        fontWeight: "500",
        textAlign: "center",
        height: "82px",
        marginTop: "60px",
        float: "center",
        "&:hover": {
            backgroundColor: theme.palette.primary.light,
            cursor: "pointer"
        }

    }

}))

const Signup = () => {

    const auth = authService

    const history = useHistory();

    const [email, setEmail] = useState("");

    const style = useStyles();


    const onChange = (e) => {

        setEmail(e.target.value);

    }

    const onSubmit = (e) => {

        e.preventDefault();

        if (!email.includes("@")) {
            return toast.error("올바른 이메일 형식이 아닙니다.");
        }

        emailCheck(email).then(res => {
            if (res.type === false) {
                toast.error("이미 가입된 이메일입니다.")
            } else {
                const actionCodeSettings = {
                    url: process.env.REACT_APP_REGISTER_REDIRECT_URL,
                    handleCodeInApp: true,
                };

                sendSignInLinkToEmail(auth, email, actionCodeSettings).then(() => {
                    //console.log("email sent")
                    window.localStorage.setItem("emailForSignIn", email);
                    setEmail("");
                    toast("이메일을 보냈습니다. 인증을 완료해주세요.", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }).catch(err => {
                    console.log(err);
                    toast.error("이메일을 보내는데 실패했습니다.");
                })
            }
        }).catch(err => {
            console.log(err);
            toast.error("이메일을 보내는데 실패했습니다.");
        })






        //   history.push("/register");

    }

    return (
        <div className={style.container}>

            <div className={style.wrapper}>
                <h1>SurBay 회원가입</h1>
                <div className={style.write}>이메일 인증 절차를 통해 더 나은 서비스를 제공하고자 합니다.</div>
                <br />
                <br />
                <h2>이메일 인증하기</h2>

                <form>
                    <input type="text" className={style.email} value={email} onChange={onChange} placeholder="surbay.official@gmail.com" required />
                    <br />
                    <button className={style.button} onClick={onSubmit}>다음</button>
                </form>

            </div>
        </div>
    );
};

export default Signup;